import React from 'react'
import './font.css'
import './index.css'
import App from './App'
import {createRoot} from "react-dom/client";

//TODO: uncomment this for production builds:
// console.log = function() {}

const container = document.getElementById('app');
const root = createRoot(container);

root.render(
  <React.StrictMode>
    <App/>
  </React.StrictMode>,
);
